import React, { useState, useEffect } from 'react';
import { Modal, Input } from 'antd';
import './DeleteConfirmModal.css';

// Type-to-confirm delete dialog. The Delete button stays disabled until the user types
// `nameToType` exactly (whitespace-trimmed). Reused for journeys and touchpoints. AntD
// 4.16 Modal takes `visible`, not `open`; this component exposes `open` and maps it.
export default function DeleteConfirmModal({ open, title, nameToType, body, confirming = false, onConfirm, onCancel }) {
  const [value, setValue] = useState('');
  // Reset the field whenever the dialog opens, so reopening never keeps a stale match.
  useEffect(() => { if (open) setValue(''); }, [open]);
  const matches = value.trim() === String(nameToType).trim();
  const submit = () => { if (matches && !confirming) onConfirm(); };
  return (
    <Modal
      className="del-confirm-modal"
      visible={open}
      title={title}
      onCancel={onCancel}
      onOk={submit}
      okText="Delete"
      okType="danger"
      okButtonProps={{ disabled: !matches, loading: confirming }}
      cancelButtonProps={{ disabled: confirming }}
      maskClosable={!confirming}
    >
      <div className="del-body">{body}</div>
      <Input
        aria-label="type-to-confirm"
        placeholder={nameToType}
        value={value}
        disabled={confirming}
        onChange={(e) => setValue(e.target.value)}
        onPressEnter={submit}
        style={{ marginTop: 10 }}
      />
    </Modal>
  );
}
